import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
const MARKER_FONT = "'Permanent Marker', cursive";
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      delay: i * 0.12,
      ease: 'easeOut'
    }
  })
};
const funnelSteps = [{
  label: 'Applications Received',
  value: '1,200+',
  width: '100%',
  opacity: 0.25
}, {
  label: 'Resume Screen Passed',
  value: '340',
  width: '82%',
  opacity: 0.4
}, {
  label: 'Phone Screen Passed',
  value: '180',
  width: '62%',
  opacity: 0.6
}, {
  label: 'Final Interviews Booked',
  value: '102',
  width: '44%',
  opacity: 0.8
}, {
  label: 'Hires Made',
  value: '21',
  width: '28%',
  opacity: 1
}];
export function FunnelSection() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    amount: 0.2
  });
  return <section className="relative w-full bg-[#1A2B4A] grid-texture py-24 px-6 overflow-hidden" data-id="element-251">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#4ECDC4]/8 rounded-full blur-[100px] pointer-events-none" data-id="element-252" />

      <div ref={ref} className="max-w-3xl mx-auto relative z-10" data-id="element-253">
        <motion.div custom={0} variants={fadeUp} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="text-center mb-14" data-id="element-254">
          <span className="inline-block bg-[#4ECDC4] text-[#1A2B4A] text-xs font-bold uppercase px-3 py-1 rounded-full mb-4 tracking-wider" data-id="element-255">
            Real Client Data
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4 leading-tight" data-id="element-256">
            From 1,200 Applicants to{' '}
            <span className="text-[#4ECDC4]" data-id="element-257">21 Elite Hires</span> in 10 Days
          </h2>
        </motion.div>

        {/* Funnel visualization */}
        <div className="relative flex flex-col items-center gap-1 mb-10" data-id="element-258">
          {funnelSteps.map((step, i) => <motion.div key={step.label} custom={i + 1} variants={fadeUp} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="w-full flex flex-col items-center" data-id="element-259">
              <div className="relative rounded-xl backdrop-blur-sm border transition-all px-4 sm:px-6 py-3 sm:py-4" style={{
            width: step.width,
            minWidth: '220px',
            backgroundColor: `rgba(78, 205, 196, ${step.opacity * 0.18})`,
            borderColor: `rgba(78, 205, 196, ${step.opacity * 0.5})`,
            boxShadow: i === funnelSteps.length - 1 ? '0 0 30px rgba(78, 205, 196, 0.3)' : 'none'
          }} data-id="element-260">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-0.5 sm:gap-4" data-id="element-261">
                  <span className="text-xs sm:text-sm font-medium text-white/80 leading-tight" data-id="element-262">
                    {step.label}
                  </span>
                  <span className="font-black flex-shrink-0" style={{
                color: i === funnelSteps.length - 1 ? '#4ECDC4' : 'white',
                fontSize: i === funnelSteps.length - 1 ? '1rem' : undefined
              }} data-id="element-263">
                    {step.value}
                  </span>
                </div>

                {/* Marker annotations on select rows */}
                {i === 0 && <span className="hidden sm:block absolute -right-36 top-1/2 -translate-y-1/2 text-white/80 text-sm pointer-events-none select-none" style={{
              fontFamily: MARKER_FONT,
              transform: 'translateY(-50%) rotate(4deg)',
              whiteSpace: 'nowrap'
            }} data-id="element-264">
                    we filter all of this →
                  </span>}
                {i === 2 && <span className="hidden sm:block absolute -right-32 top-1/2 -translate-y-1/2 text-white/80 text-sm pointer-events-none select-none" style={{
              fontFamily: MARKER_FONT,
              transform: 'translateY(-50%) rotate(-3deg)',
              whiteSpace: 'nowrap'
            }} data-id="element-265">
                    AI handles this!
                  </span>}
                {i === funnelSteps.length - 1 && <span className="hidden sm:block absolute -right-28 top-1/2 -translate-y-1/2 text-[#4ECDC4]/90 text-sm pointer-events-none select-none" style={{
              fontFamily: MARKER_FONT,
              transform: 'translateY(-50%) rotate(5deg)',
              whiteSpace: 'nowrap'
            }} data-id="element-266">
                    only the best ★
                  </span>}
              </div>
              {i < funnelSteps.length - 1 && <div className="w-0.5 h-3 bg-[#4ECDC4]/30" data-id="element-267" />}
            </motion.div>)}
        </div>

        {/* Callout */}
        <motion.div custom={6} variants={fadeUp} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="bg-white/10 backdrop-blur-sm border border-[#4ECDC4]/30 rounded-2xl p-6 text-center mb-12" data-id="element-268">
          <p className="text-white font-semibold text-lg" data-id="element-269">
            You only see the candidates worth hiring.{' '}
            <span className="text-[#4ECDC4]" data-id="element-270">We handle the other 1,179.</span>
          </p>
        </motion.div>

        <motion.div custom={7} variants={fadeUp} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="flex justify-center" data-id="element-271">
          <CTAButton data-id="element-272" />
        </motion.div>
      </div>
    </section>;
}